<template>
<m-pageframe
    :title="page_title"
>

<v-container
    fluid
    style="padding-right: 15px; padding-left: 15px;"
>

<v-stepper 
        v-model="stage" 
        vertical
        v-if="stage != 0"
    >
         <v-stepper-step 
            step="1" 
            :complete="stage > 1"
        >
            General Information
        </v-stepper-step>

        <v-stepper-content step="1">
            <m-display-text
                label = "Organization Id"
                v-model="profile.organization_account.organization_id"
            />

            <v-text-field
                label = "Organization Name"
                v-model="profile.organization_account.label"
                ref="organization_name"
                autocomplete="off"
            />

            <m-edit-select-enum
                label="Industry"
                v-model="profile.organization_account.industry"
                enum_name="industry_code"
                dialog_title="Select industry"
                :allow_any_enum_value="false"
            />

            <v-select
                label="Primary Time Zone"
                :items="$rc.commonTimeZones()"
                v-model="profile.organization_account.primary_timezone"
            />

            <m-autocomplete-country-and-subdivision
                v-model="profile.organization_account.country_and_subdivision"
            />

            <v-checkbox
                style="margin-top: -5px"
                label="Archived"
                v-model="profile.organization_account.is_archived"
            />

            <v-checkbox
                style="margin-top: -15px"
                label="Non-Revenue"
                :value="!profile.organization_account.is_revenue_account"
                v-on:change="onChangeNonRevenue"
            />

            <v-checkbox
                style="margin-top: -15px"
                label="RedChirp Promotion Prohibited"
                v-model="profile.organization_account.red_chirp_promotion_prohibited"
            />

            <v-btn
                color="primary"
                v-on:click="createNewOrganization"
                :disabled="!isValidGeneral()"
            >
                Create New Organization
            </v-btn>
        </v-stepper-content>

        <v-stepper-step 
            step="2" 
            :complete="stage > 2"
        >
            Organization Bot Phone Number
        </v-stepper-step>

        <v-stepper-content step="2">
            <v-btn
                color="primary"
                v-on:click="registerBotPhoneNumber"
            >
                Register Bot Phone Number
            </v-btn>

        </v-stepper-content>

        <v-stepper-step 
            step="3" 
            :complete="stage > 3"
        >
            Add RedChirp User
        </v-stepper-step>

        <v-stepper-content step="3">
           <m-settings-organization-team-members
                :profile="profile"
                :show_search_bar="false"
                v-on:patch-employee="patchEmployee"
                v-on:add-team-member="addTeamMember"
                v-on:set-password="onSetPassword"
                style="margin-bottom: 5px;"
            />
        </v-stepper-content>

        <m-admin-organization-auto-action-dialog
            ref="auto-action-dailog"
            v-on:create-org="onCreateOrgWithAutoAction"
        />

</v-stepper>


</v-container>

<v-overlay
    
    opacity="0.3"
    :value="show_spinner"
    z-index="10"
>
     <v-progress-circular
      :size="70"
      :width="7"
      color="primary"
      indeterminate
    ></v-progress-circular>
</v-overlay>

<m-settings-organization-add-phone-number
    ref="add_phone_number"
    v-on:ok="reloadProfile()"
/>


</m-pageframe>
</template>

<script>
const TestData = require("@/js/TestData.js");

export default {
    data() {
        return {
            show_spinner: false,
            stage: 0,
            profile: this.createDefaultProfile(),
        }
    },
    mounted () {
        this.reloadProfile();
    },

    methods: {
        reloadProfile()
        {
            this.show_spinner = true;

            this.$rc.getOrganizationProfile(
                this.$route.params.organization_id, 

                (profile) => {
                    this.show_spinner = false;
                    this.profile = profile;

                    if ( profile.endpoints.length != 0 )
                        this.stage = 3;
                    else
                        this.stage = 2;
                },

                () => {
                    // The organization does not exist, so attempt a load from the CRM general organization info
                    this.loadGeneralInformationFromProspectiveOrganization(),

                    this.stage = 1;
                    this.show_spinner = false;
                    this.$refs['organization_name'].focus();
                }
            );
        },

        loadGeneralInformationFromProspectiveOrganization()
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'GET: /api/v1/red-chirp-crm/organizations/admin-summary/:organization_id',
            
                {
                    'organization_id': this.$route.params.organization_id,
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.profile.organization_account.label = data.label;
                    this.profile.organization_account.industry = data.industry;
                    this.profile.organization_account.primary_timezone = data.primary_timezone;
                    this.profile.organization_account.is_archived = data.is_archived;
                    this.profile.organization_account.is_revenue_account = data.is_revenue_account;
                    this.profile.organization_account.red_chirp_promotion_prohibited = data.red_chirp_promotion_prohibited;

                    if ( data.country_and_subdivision != null )
                        this.profile.organization_account.country_and_subdivision = data.country_and_subdivision;
                    
                },
            
                () => {
                    this.$rc.hideSpinner();
                },
            );
        },

        createDefaultProfile()
        {
            return {
                'organization_account': {
                    'organization_id' : this.$route.params.organization_id,
                    'industry' : 'uncategorized',
                    'label' : '',
                    'primary_timezone' : 'US/Arizona',
                    'country_and_subdivision' : 'US-AZ',
                    'inboxes' : 'create_default',
                    'inbox_urls' : 'create_default',
                    'groups' : 'create_default',
                    'creation_date' : new Date().toISOString().substring(0,10),
                    'is_revenue_account' : true,
                    'is_archived': false,
                    'organization_state': 'pre-launch',
                    'features' : {
                    },
                },
            };
        },

        isValidGeneral()
        {
            return this.profile.organization_account.label.trim().length != 0 && this.profile.organization_account.industry != 'uncategorized';
        },

        createNewOrganization()
        {
            this.$refs['auto-action-dailog'].showDialog(this.profile.organization_account);
        },

        onCreateOrgWithAutoAction(selected_auto_actions)
        {
            this.show_spinner = true;

            this.$rc.showSpinner();

            let post_data = this.profile.organization_account;
            post_data['auto_actions'] = selected_auto_actions;

            this.$rc.rest(
                'PUT: /api/v1/organizations/organization-account',
            
                post_data,
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.reloadProfile()
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to update organization');
                },
            );
        },

        registerBotPhoneNumber()
        {
            this.$refs['add_phone_number'].showDialog(this.profile.organization_account.organization_id, true, null, true);
        },

        patchEmployee(changes)
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PATCH: /api/v1/employees',
            
                'params' : changes,
            
                'on_success': (data) => {
                        this.reloadProfile();
                    },
            
                'on_error': 'Unable to update employee account',
            });
        },

        addTeamMember(new_team_member_data)
        {
            this.show_loading = true;
            this.$forceUpdate();
            this.$rc.createEmployee(new_team_member_data, () => this.afterAddTeamMember(new_team_member_data), (message) => alert(message) );
        },

        afterAddTeamMember(new_team_member_data)
        {
            this.reloadProfile();
            
            if ( new_team_member_data.team_member_phone_number != 'new_number' )
            {
                return;
            }

            this.startOrderPhoneNumberForEmployee(new_team_member_data.employee_id);
        },

        startOrderPhoneNumberForEmployee(employee_id)
        {
            this.$refs['add_phone_number'].showDialog(this.$route.params.organization_id, true, employee_id);
        },

        onSetPassword(password_data)
        {
            this.$rc.setPassword(password_data, () => alert('Password changed'), (message) => alert(message));
        },

        onChangeNonRevenue(value)
        {
            this.profile.organization_account.is_revenue_account = !value;
        }

    },

    computed: {
        page_title() {
            if ( this.isValidGeneral() )
            {
                return 'Organization Setup Wizard: '+this.profile.organization_account.label;
            }

            return 'Organization Setup Wizard';
        },
    },
}
</script>

<style lang="scss" scoped>

</style>